function getSelectableFilteredIds(generalEvents, visitEvents, filterText) {
  const query = filterText.toLowerCase();
  const matches = (event) =>
    !event.is_self_scheduled && event.name.toLowerCase().includes(query);
  return [...generalEvents.filter(matches), ...visitEvents.filter(matches)].map(
    (event) => event.id
  );
}

export default getSelectableFilteredIds;
